import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export const libreViewConnectionStatusSchema = z.literal(["ok", "not_configured", "needs_manual_login", "auth_failed"]);
export type LibreViewConnectionStatus = z.output<typeof libreViewConnectionStatusSchema>;

export type LibreViewStatusResponse = { status: LibreViewConnectionStatus };
export const libreViewStatusResponseSchema: Schema<LibreViewStatusResponse> = cz.camelCaseObject({
  status: libreViewConnectionStatusSchema,
});

export type LibreViewClinicPatient = {
  libreviewId: string;
  firstName: string;
  lastName: string;
  email: string;
  tir?: number;
  tbr?: number;
  age?: number;
  lastDataSince?: string;
  phoneNumber?: string;
};

export const libreViewClinicPatientSchema: Schema<LibreViewClinicPatient> = cz.camelCaseObject({
  libreview_id: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  tir: cz.optional(z.number()),
  tbr: cz.optional(z.number()),
  age: cz.optional(z.number()),
  last_data_since: cz.optional(cz.datetime()),
  phone_number: cz.optional(z.string()),
});

export const libreViewClinicPatientsResponseSchema: Schema<LibreViewClinicPatient[]> = cz.transform(
  z.object({ patients: cz.forcedArray(libreViewClinicPatientSchema) }),
  data => data.patients,
);

export type LibreViewClinicPatientsFilters = {
  tirMax?: number;
  tbrMin?: number;
  lastDataMaxAgeDays?: number;
};

export const libreViewIgnoreTypeSchema = z.literal(["refused_during_pre_inclusion"]);
export type LibreViewIgnoreType = z.output<typeof libreViewIgnoreTypeSchema>;
